export const DATADOG_SITE = "us5.datadoghq.com";
